import { connect } from 'react-redux';
import { BaseApp } from '../components';

function mapStateToProps(state) {
  return { contact: state.contact };
}

export const AppContainer = connect(mapStateToProps)(BaseApp);
export default AppContainer;
